import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from '../../../services/urls';
import axiosInstance from '../../../ns_libs/nsAxios';
import { trackDatadogRumError } from '../../../utils/initDatadogRum';
import { OrganizationSubproject } from '../types';

interface IParams {
    orgId: string;
    ownedByOrg?: boolean;
    searchValue?: string;
    sortCol?: string[];
    sortOrder?: 'asc' | 'desc';
    enabled?: boolean;
}

const getOrganizationSubprojects = async (params: IParams) => {
    const {
        orgId, ownedByOrg, searchValue, sortCol, sortOrder,
    } = params;

    const response = await axiosInstance.get<OrganizationSubproject[]>(API_ENDPOINTS.ORGANIZATION_SUBPROJECTS(orgId), {
        params: {
            searchValue,
            sortCol,
            sortOrder,
            ownedByOrg,
        },
    });

    if (!Array.isArray(response.data)) {
        trackDatadogRumError(
            new Error('[useOrganizationSubprojects] Expected array response'),
            { receivedType: typeof response.data, receivedValue: response.data },
        );
        return [];
    }
    return response.data;
};

const useOrganizationSubprojects = ({
    orgId, ownedByOrg = false, searchValue, sortCol, sortOrder, enabled = true,
}: IParams) => useQuery({
    queryKey: ['organization-projects', orgId, ownedByOrg, searchValue, sortCol, sortOrder],
    queryFn: () => getOrganizationSubprojects({
        orgId, ownedByOrg, searchValue, sortCol, sortOrder,
    }),
    enabled,
});

export default useOrganizationSubprojects;
